import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const ADVANCED_SETTINGS = 'advanced settings'
export const SEARCH_QUOTA = 'search quota'

export default {
  [PORTUGUESE]: {
    [ADVANCED_SETTINGS]: 'Configurações Avançadas',
    [SEARCH_QUOTA]: 'Pesquisar ou adicionar uma cota',
  },

  [ENGLISH]: {
    [ADVANCED_SETTINGS]: 'Advanced Settings',
    [SEARCH_QUOTA]: 'Search or add a quota',
  },

  [SPANISH]: {
    [ADVANCED_SETTINGS]: 'Ajustes Avanzados',
    [SEARCH_QUOTA]: 'Buscar o agregar una cuota',
  },
}
